import { GenerateVonqClientTokenDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useGenerateVonqClientToken = () => {
  const [generateToken, { data }] = useMutation(GenerateVonqClientTokenDocument, {
    extractorFn: (data) => data.atsMutations.createAtsVonqClientToken,
  })
  const clientToken = data?.atsMutations.createAtsVonqClientToken.vonqClientToken

  return {
    generateToken: (companyId: number) => {
      generateToken({ variables: { companyId } })
    },
    clientToken,
  }
}
